//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["openStatus", "orderId"],
  data() {
    return {
      stepLoading: false,
      dialogVisible_send: false,
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      dynamicValAddForm: {
        contacts: "",
        telPhone: "",
        remark: "",
        orderId: "",
        saleOrderTime: "",
      },
      sendRules: {
        saleOrderTime: [
          {
            required: true,
            message: "请发货时间",
            trigger: "change",
          },
        ],
        contacts: [
          { required: true, message: "请输入承运人姓名", trigger: "blur" },
        ],
        telPhone: [
          { required: true, message: "请输入承运人联系方式", trigger: "blur" },
        ],
        remark: [{ required: true, message: "请输入备注", trigger: "blur" }],
      },
      checked1: false,
    };
  },
  watch: {
    openStatus(val1, val2) {
      this.dialogVisible_send = this.openStatus;
    },
  },
  mounted() {
    if(sessionStorage.getItem("infoShObj") != null) {
      this.dynamicValAddForm = JSON.parse(sessionStorage.getItem("infoShObj"))[0];
    }
    this.dynamicValAddForm.orderId = this.orderId;
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.sendOrderList();
        } else {
          return false;
        }
      });
    },
    
    // 修改收货人信息接口
    sendOrderList() {
      this.stepLoading = true;
      this.$http.szOrder.confirmDelivery(this.dynamicValAddForm).then((res) => {
        this.stepLoading = false;
        if (res.status == 1) {
          this.dialogVisible_send = false;
          this.$emit("closeSendStatus", true);
          this.$message({
            message: "发货成功",
            type: "success",
          });
          setTimeout(() => {
            this.stepLoading = false;
          }, 1000);
        }
      });
    },
    handleClose() {
      this.dialogVisible_send = false;
      this.$emit("closeStatus", true);
    },
  },
};
